import { ITrack } from '@/data/models/track';
import { IValidationResults } from '@/data/models/validation';
import { IAlbum } from '@/data/models/album';
import { useTrackEditView } from '@/hooks/useTrackEditView';
import React from 'react';
import TrackEditViewTemplate from '@/components/partials/ProductTabs/TrackEditView/TrackEditViewTemplate';
import { IChangeRequest } from '@/data/models/changeRequest';
import { ICurrentTracksChangesGroup } from '@/types/product-current-changes-types';

interface Props {
  togglePopUp: any;
  trackObj: ITrack;
  reloadTracks: any;
  errorFlag?: boolean;
  errors?: IValidationResults[];
  readonly?: boolean;
  disabled?: boolean;
  catalogUpc?: string | null;
  loadPreviousTrack?: () => void;
  loadNextTrack?: () => void;
  usesSides?: boolean;
  album?: IAlbum;
  changeRequest?: IChangeRequest;
  currentChanges?: ICurrentTracksChangesGroup;
}

const SingleTrackEdit = (props: Props) => {
  const hookData = useTrackEditView({
    ...props,
    errorFlag: props.errorFlag ?? false,
    errors: props.errors ?? [],
    readonly: props.readonly ?? false,
    disabled: props.disabled ?? false,
    changeRequest: props.changeRequest,
  } as any);

  const isChangeRequest = !!props.changeRequest;

  return (
    <TrackEditViewTemplate
      readonly={props.readonly}
      disabled={props.disabled}
      usesSides={props.usesSides}
      formatName={props.album?.format?.name}
      trackData={hookData.track}
      showPopUp={hookData.showPopUp}
      onCancel={hookData.onCancel}
      closePopUp={hookData.closePopUp}
      isSubmitting={hookData.isSubmitting}
      showCancelChangesModal={hookData.showCancelChangesModal}
      setShowCancelChangesModal={hookData.setShowCancelChangesModal}
      handleSubmit={hookData.handleSubmit}
      handleInput={hookData.handleInput}
      handleArtist={hookData.handleArtist}
      handleWriterComposer={hookData.handleWriterComposer}
      handlePublisher={hookData.handlePublisher}
      handleDuration={hookData.handleDuration}
      errorBanner={hookData.errorBanner}
      errorMessages={hookData.errorMessages}
      validationErrors={hookData.trackIssues}
      saveErrorMessage={hookData.saveErrorMessage}
      onSaveErrorClose={() => hookData.setSaveErrorMessage(null)}
      isTrackValid={hookData.isTrackValid}
      fieldHasErrors={hookData.fieldHasErrors}
      fieldValidationState={hookData.fieldValidationState}
      findErrorMessage={hookData.findErrorMessage}
      previousTrack={hookData.previousTrack}
      nextTrack={hookData.nextTrack}
      formatTrackLabel={hookData.formatTrackLabel}
      currentChanges={props.currentChanges}
      isChangeRequest={isChangeRequest}
      albumState={props.album?.albumState}
    />
  );
};

export default SingleTrackEdit;
